
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
// import { getToken } from '@/utils/auth'

import qs from 'qs'

// create an axios instance
const service = axios.create({
  // baseURL: 'https://applet.gtym.net/uac', // url = base url + request url
  baseURL: 'https://applet.gtym.net/uac/', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    let user=localStorage.getItem('USERINFO');
    // debugger
    // config.params.equipmentInformation={equipment:4, edition:'1.0.0', uuid:0};
    if(user){
      user=JSON.parse(user);
      config.headers['frontAccountToken']=user.frontAccountToken;
      config.headers['equipmentInformation']=JSON.stringify({equipment:4, edition:'1.0.0', uuid:0});
    }
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-Token'] = getToken()
    }
    // if(config.method=='post'){
    //   config.headers['Content-Type']='application/x-www-form-urlencoded';
    //   // config.transformRequest=[
    //   //   function (data) {
    //   //     // `transformRequest` 允许在向服务器发送前，修改请求数据
    //   //     // 只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
    //   //     // data.sex = 'man'
    //   //     return qs.stringify(data)
    //   //     // 结合create_headers里的内容，在这里又新增一条信息sex=man
    //   //     // 因此network中查看的结果是：name=xiaoming&age=12&sex=man
    //   //   }
    //   // ]
    // }
    // console.log(config)
    return config;
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    console.log(res,'111')

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      if(res.code==401){
        localStorage.removeItem("USERINFO");
        localStorage.removeItem("CUROFFER");
        //   MessageBox.confirm(
        //     '登录状态已过期，您可以继续留在该页面，或者重新登录',
        //     '系统提示', {
        //         confirmButtonText: '重新登录',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }
        // ).then(() => {
        //     localStorage.removeItem("USERINFO");
        //     localStorage.removeItem("CUROFFER");
        //     location.href = '#/login'
        // })
        Message({
          message: res.message || 'Error',
          type: 'error',
        })
        return res;
      }else if(res.code==500){
        // console.log(res);
        // Message({
        //   message: res.message || 'Error',
        //   type: 'error',
        //   duration: 5 * 1000
        // })
        return res.message;
      }else if(res.code==100003 ){
        // console.log(res);
        // Message({
        //   message: res.message || 'Error',
        //   type: 'error',
        //   duration: 5 * 1000
        // })
        return res.message;
      }else{
		  Message({
		    message: res.message || 'Error',
		    type: 'error',
		  })
	  }

      // else{
      //   if(res.code!=101&&res.code!=102){
      //     Message({
      //       message: res.message || 'Error',
      //       type: 'error',
      //       duration: 5 * 1000
      //     })
      //   }
      // }
      // return Promise.reject(new Error(res.message || 'Error'))
    } else {
		
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/services/reqeust.js